<template>
  <div class="content">
    <div class="tweet-content">
      <div>
        <profile-pic v-if="miniView" :user="data.user" :mini-view="true"/>
        <link-to-profile :screen-name="data.user.screen_name" class="has-text-black"><strong>{{
            data.user.name
          }}</strong></link-to-profile>
        <b-icon v-if="data.user.verified" type="is-info" icon="check-circle"></b-icon>
        <b-icon v-if="data.user.protected" type="is-info" icon="lock"></b-icon>
        <small class="has-text-muted pl-1">
          <link-to-profile :screen-name="data.user.screen_name">@{{ data.user.screen_name }}</link-to-profile>
          <template v-if="createdSince">
            &bull;
            <span class="time-since">
              <link-to-tweet :id="data.id" :screen_name="data.user.screen_name">
                {{ createdSince }} ago
              </link-to-tweet>
            </span>
          </template>
        </small>
      </div>
      <tweet-retweeted v-if="data.retweeted_by" :data="data"></tweet-retweeted>

      <div v-if="data.in_reply_to && !collapseContent">
        <small class="has-text-grey is-clickable" @click="$store.dispatch('loadThread', data)">
          <span v-if="data.in_reply_to.screen_name === data.user.screen_name">Part of thread</span>
          <span v-else>In reply to @{{ data.in_reply_to.screen_name }}</span>
        </small>
      </div>
      <p v-if="!collapseContent" :class="['tweet-html', clickable ? 'is-clickable' : '']" v-html="data.html"
         @click="handleClicks"/>
    </div>
  </div>
</template>
<script>

import {parseISO, formatDistance} from 'date-fns'
import LinkToTweet from "../controls/LinkToTweet"
import LinkToProfile from "../controls/LinkToProfile"
import ProfilePic from "../ProfilePic"
import TweetRetweeted from "./TweetRetweeted"

export default {
  name: 'tweet-content',
  components: {TweetRetweeted, ProfilePic, LinkToProfile, LinkToTweet},
  props: {
    data: Object,
    clickable: {
      type: Boolean,
      default: true
    },
    miniView: {
      type: Boolean,
      default: false
    },
    collapseContent: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    createdSince() {
      // this can be blank on a scheduled tweet
      if (this.data.created_at) {
        let created = parseISO(this.data.created_at)
        return formatDistance(created, this.$now.datetime, {includeSeconds: true})
      }
      return undefined
    }
  },
  methods: {
    handleClicks(event) {
      // capture clicks and push to router if a local link
      // https://dennisreimann.de/articles/delegating-html-links-to-vue-router.html
      let {target} = event
      while (target && target.tagName !== 'A') {
        target = target.parentNode
      }
      if (target) {
        if (target.matches("a:not([href*='://'])") && target.href) {
          const {altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented} = event
          if (metaKey || altKey || ctrlKey || shiftKey) return
          if (defaultPrevented) return
          if (button !== undefined && button !== 0) return
          if (target && target.getAttribute) {
            const linkTarget = target.getAttribute('target')
            if (/\b_blank\b/i.test(linkTarget)) return
          }
          const url = new URL(target.href)
          const to = url.pathname
          if (window.location.pathname !== to && event.preventDefault) {
            event.preventDefault()
            this.$router.push(to)
          }
        }

      } else if (this.clickable) {
        this.$store.dispatch('loadThread', this.data);
      }

    }
  }
}
</script>
